<script setup lang="ts">
import { ArrowUpRightIcon } from 'lucide-vue-next'
import { DropdownMenuItem } from '../../ui/dropdown-menu'
import type { Elemental } from '~~/src/types/elemental'
const { elemental, route } = defineProps<{
  elemental: Elemental
  route: string
}>()

const { push } = useRouter()
const open = () => {
  push(`/${route}/${elemental.url}`)
}
defineOptions({
  name: 'OpenElementalLinkOption',
})
</script>

<template>
  <DropdownMenuItem @select="open">
    <ArrowUpRightIcon />
    Open Public Page
  </DropdownMenuItem>
</template>
